import React, {Component} from "react";
import PropTypes from "prop-types";
import ProjectModel from "../models/project";

export default class ProjectDetails extends Component {
    render() {
        if (this.props.model === undefined) {
            return (
                <div className="card">
                    <div className="card-body">
                        <p className="card-text">
                            Kein Projekt ausgewählt.
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">{this.props.model.name}</h5>
                    <p className="card-text">
                        {this.props.model.id}, {this.props.model.number}
                    </p>
                </div>
            </div>
        )
    }
}

ProjectDetails.propTypes = {
    model: PropTypes.instanceOf(ProjectModel)
};



// WEBPACK FOOTER //
// ./src/components/ProjectDetails.js